// src/components/ConfirmDialog.js
//
// Extracted from Admin.js (where it originally lived inline for the
// Danger Zone actions) so the same typed-confirmation pattern can be
// reused by AdminDevTools.js without copy-pasting it. Behavior is
// unchanged from the original.

import React, { useState } from 'react';

function ConfirmDialog({ message, onConfirm, onCancel, requireTyped }) {
    const [typed, setTyped] = useState('');
    const ready = !requireTyped || typed === 'DELETE';
    return (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', zIndex: 50, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div className="bg-gray-900 border border-gray-700 rounded-2xl p-8 max-w-md w-full mx-4">
                <h3 className="text-lg font-black text-white mb-3">Are you sure?</h3>
                <p className="text-gray-400 text-sm mb-6">{message}</p>
                {requireTyped && (
                    <div className="mb-6">
                        <p className="text-xs text-gray-500 mb-2">Type DELETE to confirm</p>
                        <input type="text" value={typed} onChange={e => setTyped(e.target.value)}
                            className="w-full bg-gray-800 border border-gray-700 rounded-lg px-4 py-2 text-white focus:outline-none focus:border-red-500"
                            placeholder="DELETE" />
                    </div>
                )}
                <div className="flex gap-3">
                    <button onClick={onCancel}
                        className="flex-1 bg-gray-800 hover:bg-gray-700 text-white font-bold py-2 rounded-lg transition-colors">
                        Cancel
                    </button>
                    <button onClick={onConfirm} disabled={!ready}
                        className="flex-1 bg-red-600 hover:bg-red-700 disabled:bg-red-900 disabled:text-red-700 text-white font-bold py-2 rounded-lg transition-colors">
                        Confirm
                    </button>
                </div>
            </div>
        </div>
    );
}

export default ConfirmDialog;
